// extracted by mini-css-extract-plugin
export default {"header":"Header_header__+hcWW","headerImg":"Header_headerImg__iLZmx","linkphone":"Header_linkphone__OLQyl","imgLogo":"Header_imgLogo__BehRw"};